module.exports = __webpack_public_path__ + "img/78.068180b4.jpg";